module.exports = {
	"actions.buy": "Buy {price}",
	"actions.buy-from": "Buy from {price}",
	"actions.purchased": "You own this video",
	"actions.rent": "Rent {price}",
	"actions.rented": "Rented until {date}",
	"actions.subscribe": "Subscribe {price}/month",
	"fullscreen.enter": "Full screen",
	"fullscreen.exit": "Exit full screen",
	"info-overlay.cast": "cast",
	"info-overlay.created-by": "By {author}",
	"info-overlay.crew": "crew",
	"overlay.buy-from": "Buy from {price}",
	"overlay.source-error": "Video cannot be played",
	"quality.auto": "Auto",
	"quality.format": "{qualityValue}p",
	"quality.label": "Quality",
	"share-overlay.share": "Share this video",
	"shared.crew.2nd-assistant-director": "2nd Assistant Director",
	"shared.crew.2nd-unit-dir-of-photography": "2nd Unit Dir of Photography",
	"shared.crew.academic-advisor": "Academic Advisor",
	"shared.crew.adaptation": "Adaptation",
	"shared.crew.additional-grip": "Additional Grip",
	"shared.crew.additional-photography": "Additional Photography",
	"shared.crew.agent": "Agent",
	"shared.crew.animal-trainer": "Animal Trainer",
	"shared.crew.animator": "Animator",
	"shared.crew.art-director": "Art Director",
	"shared.crew.assistant-art-director": "Assistant Art Director",
	"shared.crew.assistant-camera": "Assistant Camera",
	"shared.crew.assistant-director": "Assistant Director",
	"shared.crew.assistant-editor": "Assistant Editor",
	"shared.crew.associate-producer": "Associate Producer",
	"shared.crew.author-of-adapted-material": "Author of Adapted Material",
	"shared.crew.best-boy": "Best Boy",
	"shared.crew.boom-operator": "Boom Operator",
	"shared.crew.cable-person": "Cable Person",
	"shared.crew.camera-operator": "Camera Operator",
	"shared.crew.choreographer": "Choreographer",
	"shared.crew.cinematographer-dp": "Cinematographer/DP",
	"shared.crew.co-director": "Co-Director",
	"shared.crew.co-producer": "Co-Producer",
	"shared.crew.co-writer": "Co-Writer",
	"shared.crew.collaborating-director": "Collaborating Director",
	"shared.crew.costume-designer": "Costume Designer",
	"shared.crew.costumer": "Costumer",
	"shared.crew.digital-effects": "Digital Effects",
	"shared.crew.director": "Director",
	"shared.crew.dolly-grip": "Dolly Grip",
	"shared.crew.editor": "Editor",
	"shared.crew.executive-producer": "Executive Producer",
	"shared.crew.gaffer": "Gaffer",
	"shared.crew.grip": "Grip",
	"shared.crew.hairstylist": "Hairstylist",
	"shared.crew.key-grip": "Key Grip",
	"shared.crew.lead-person": "Lead Person",
	"shared.crew.location-manager": "Location Manager",
	"shared.crew.makeup-artist": "Makeup Artist",
	"shared.crew.makeup-effects": "Makeup Effects",
	"shared.crew.manager": "Manager",
	"shared.crew.original-music-composer": "Original Music/Composer",
	"shared.crew.preview-return": "Preview Return",
	"shared.crew.print-return": "Print Return",
	"shared.crew.print-shipper": "Print Shipper",
	"shared.crew.producer": "Producer",
	"shared.crew.production-assistant": "Production Assistant",
	"shared.crew.production-coordinator": "Production Coordinator",
	"shared.crew.production-designer": "Production Designer",
	"shared.crew.production-manager": "Production Manager",
	"shared.crew.property-master": "Property Master",
	"shared.crew.publicist": "Publicist",
	"shared.crew.school-administrator": "School Administrator",
	"shared.crew.script-supervisor": "Script Supervisor",
	"shared.crew.set-decorator": "Set Decorator",
	"shared.crew.set-designer": "Set Designer",
	"shared.crew.sound-editor": "Sound Editor",
	"shared.crew.sound-mixer": "Sound Mixer",
	"shared.crew.special-effects": "Special Effects",
	"shared.crew.story": "Story",
	"shared.crew.stunt-coordinator": "Stunt Coordinator",
	"shared.crew.swing-gang": "Swing Gang",
	"shared.crew.technical-advisor": "Technical Advisor",
	"shared.crew.video-operator": "Video Operator",
	"shared.crew.writer": "Writer",
	"shared.genres.action": "Action",
	"shared.genres.adventure": "Adventure",
	"shared.genres.african": "African",
	"shared.genres.african-american": "African American",
	"shared.genres.animation": "Animation",
	"shared.genres.asian": "Asian",
	"shared.genres.asian-american": "Asian American",
	"shared.genres.biography": "Biography",
	"shared.genres.black": "Black",
	"shared.genres.buddhist": "Buddhist",
	"shared.genres.children": "Children",
	"shared.genres.christian": "Christian",
	"shared.genres.comedy": "Comedy",
	"shared.genres.crime": "Crime",
	"shared.genres.developing-nations": "Developing Nations",
	"shared.genres.disability-culture": "Disability Culture",
	"shared.genres.diy": "DIY",
	"shared.genres.documentary": "Documentary",
	"shared.genres.drama": "Drama",
	"shared.genres.education": "Education",
	"shared.genres.family": "Family",
	"shared.genres.fantasy": "Fantasy",
	"shared.genres.film-noir": "Film-Noir",
	"shared.genres.game-show": "Game-Show",
	"shared.genres.hispanic": "Hispanic",
	"shared.genres.history": "History",
	"shared.genres.horror": "Horror",
	"shared.genres.instructional": "Instructional",
	"shared.genres.islamic": "Islamic",
	"shared.genres.jewish": "Jewish",
	"shared.genres.latino": "Latino",
	"shared.genres.lgbtq": "LGBTQ",
	"shared.genres.mature-adult": "Mature/Adult",
	"shared.genres.music": "Music",
	"shared.genres.musical": "Musical",
	"shared.genres.mystery": "Mystery",
	"shared.genres.native-aboriginal-people": "Native/Aboriginal People",
	"shared.genres.native-american": "Native American",
	"shared.genres.news": "News",
	"shared.genres.personal": "Personal",
	"shared.genres.reality-tv": "Reality-TV",
	"shared.genres.romance": "Romance",
	"shared.genres.sci-fi": "Sci-Fi",
	"shared.genres.senior-aging": "Senior/Aging",
	"shared.genres.sport": "Sport",
	"shared.genres.student": "Student",
	"shared.genres.talk-show": "Talk-Show",
	"shared.genres.thriller": "Thriller",
	"shared.genres.war": "War",
	"shared.genres.western": "Western",
	"shared.genres.women": "Women",
	"shared.genres.youth-teen": "Youth/Teen",
	"social-button.copy": "Copy",
	"social-button.facebook": "Facebook",
	"social-button.link": "Link",
	"social-button.pinterest": "Pinterest",
	"social-button.tumblr": "Tumblr",
	"social-button.twitter": "Twitter",
	"social-share.pinterest": "{title} - {description}",
	"social-share.tumblr": "{title} - {siteUrl}",
	"social-share.twitter": "Watch \"{title}\" on {siteUrl}"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_en.json
// module id = 2785
// module chunks = 66